import { LoginScreen } from "@/components/auth/LoginScreen";
import { useAuth } from "@/_core/hooks/useAuth";
import { savePostLoginRedirect } from "@/lib/authRedirect";
import { useEffect, useState } from "react";

export type RequireAuthProps = {
  /** Rota de destino preservada quando o usuário não está autenticado. */
  redirectTo: string;
  /** Título exibido na tela de login. */
  loginTitle?: string;
  /** Conteúdo exibido enquanto verifica sessão. */
  loadingFallback?: React.ReactNode;
  children: React.ReactNode;
};

export function RequireAuth({
  redirectTo,
  loginTitle,
  loadingFallback,
  children,
}: RequireAuthProps) {
  const { loading, isAuthenticated, loginWithCredentials } = useAuth();
  const [loginError, setLoginError] = useState<string | null>(null);
  const [loginLoading, setLoginLoading] = useState(false);

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      savePostLoginRedirect(redirectTo);
    }
  }, [loading, isAuthenticated, redirectTo]);

  if (loading) {
    return loadingFallback ?? null;
  }

  if (!isAuthenticated) {
    return (
      <LoginScreen
        title={loginTitle}
        error={loginError}
        loading={loginLoading}
        onSubmit={async (username, password) => {
          setLoginError(null);
          setLoginLoading(true);
          try {
            await loginWithCredentials(username, password);
          } catch (err: unknown) {
            setLoginError(err instanceof Error ? err.message : "Erro ao entrar");
          } finally {
            setLoginLoading(false);
          }
        }}
      />
    );
  }

  return <>{children}</>;
}
